export const NEW_NOTES_RETRIEVED = 'NEW_NOTES_RETRIEVED';
export const SET_RECENT_NOTES = 'SET_RECENT_NOTES';